import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-input" }
const _hoisted_2 = ["value", "placeholder"]
const _hoisted_3 = { for: "search" }

import IconSearch from "@/assets/icons/icon__search.svg";
import { useI18n } from "vue3-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchInput',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

// eslint-disable-next-line


// eslint-disable-next-line
const emit = __emit;

function handleInput(e: Event) {
  const value = (e.target as HTMLInputElement).value;
  emit("update:modelValue", value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "search",
      name: "search",
      id: "search",
      value: _ctx.modelValue,
      placeholder: _unref(t)('global.search'),
      onInput: handleInput
    }, null, 40, _hoisted_2),
    _createElementVNode("label", _hoisted_3, [
      _createVNode(_unref(IconSearch), { class: "icon icon--black" })
    ])
  ]))
}
}

})